export default {
      id: "plane-usage",
      viewBox: "0 0 26 22",
      url: __webpack_public_path__ + "img/icons.ec9c9113.svg#plane",
      toString: function () {
        return this.url;
      }
    }